import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { MarketdateComment } from './marketdate-comment.model';
import { MarketdateCommentService } from './marketdate-comment.service';

@Component({
    selector: 'jhi-marketdate-comment-detail',
    templateUrl: './marketdate-comment-detail.component.html'
})
export class MarketdateCommentDetailComponent implements OnInit, OnDestroy {

    marketdateComment: MarketdateComment;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private marketdateCommentService: MarketdateCommentService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['marketdateComment', 'commentType']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInMarketdateComments();
    }

    load(id) {
        this.marketdateCommentService.find(id).subscribe((marketdateComment) => {
            this.marketdateComment = marketdateComment;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInMarketdateComments() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateCommentListModification', (response) => this.load(this.marketdateComment.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-comment/marketdate-comment-detail.component.ts